/**
 * <video-block> — click to load.
 *
 * Third-party players are only requested once the visitor asks for them. An
 * iframe on page load would cost hundreds of kilobytes and set third-party
 * cookies for everyone, including visitors who never press play.
 */
(function () {
  'use strict';

  if (customElements.get('video-block')) return;

  const EMBEDS = {
    youtube: (id) =>
      `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&playsinline=1`,
    vimeo: (id) => `https://player.vimeo.com/video/${id}?autoplay=1&dnt=1`,
  };

  class VideoBlock extends HTMLElement {
    // No disconnectedCallback needed: the only listener is on this element's
    // own play button, and the iframe is removed with the element.
    connectedCallback() {
      this.button = this.querySelector('[data-video-play]');
      this.button?.addEventListener('click', () => this.play());
    }

    play() {
      if (this.loaded) return;
      this.loaded = true;

      const node = this.buildPlayer();
      if (!node) return;

      this.appendChild(node);
      this.button?.remove();

      // Move focus into the player so keyboard users land on the controls.
      const focusTarget = this.querySelector('iframe, video');
      focusTarget?.focus?.({ preventScroll: true });
    }

    buildPlayer() {
      const template = this.querySelector('[data-video-template]');
      if (template) {
        const fragment = template.content.cloneNode(true);
        const video = fragment.querySelector('video');
        if (video) {
          video.setAttribute('autoplay', '');
          video.setAttribute('controls', '');
          video.removeAttribute('preload');
        }
        template.remove();
        return fragment;
      }

      const { embedType, embedId } = this.dataset;
      const build = EMBEDS[embedType];
      if (!build || !embedId) return null;

      const iframe = document.createElement('iframe');
      iframe.className = 'video-block__frame';
      iframe.src = build(embedId);
      iframe.title = this.getAttribute('aria-label') || 'Video';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.loading = 'lazy';
      return iframe;
    }
  }

  customElements.define('video-block', VideoBlock);
})();
